export default theme => {
    return {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetail/theme/components/scorecard/ScorecardView/ScorecardExport.js